import { IAllocationAERepresentation, IAllocations } from './AllocationContract';
import { Link } from './CommonContract';
import { ITribeAERepresentation } from './TribeContract';

export interface IEmployeeFlat {
    Employee: IEmployee;
    Allocations: IAllocations[];
    Skills: IEmployeeSkill[];
    CurrentWorkSchedule: IEmployeeWorkSchedule;
}

export interface IEmployeeWorkSchedule {
    HoursPerWeek: string;
    StartDate: string;
    EndDate: string; // Potentially absent if workschedule has no specific end.
}

export interface IEmployeesFlat {
    Employees: IEmployee[];
    Allocations: IAllocations[];
    Skills: IEmployeeSkill[];
}

export interface IEmployee {
    Id: string;
    Name: string;
    FirstName: string;
    LastName: string;
    Email: string;
    IsConsultant: boolean;
    PostalCode: string;
    City: string;
    Phone: string;
    Sourcer: boolean;
    InternalRoles: string[];
    EngagementManagerHierarchyLayer: number;
    EngagementManagerId: string;
    LTCoachId: string;
    FirestaerterId: string;
    EmployerId: string;
    Longitude: number;
    Latitude: number;
    FunctionLevel: string;
    FunctionDescription: string;
    Profile: string;
    StartDate: Date;
    TechNonTech: string;
    CurrentAvailability: number;
    TribeId: string;
    TribeName: string;
    HiveId: string;
    HiveName: string;
    CoachRoles: CoachRole[];
}

export interface IExtendedEmployee extends IEmployee {
    LTCoachName: string;
    EMName: string;
    FirestaerterCoachName: string;
}

export interface IEmployeeHypermediaRepresentation {
    Id: string;
    Name: string;
    FirstName: string;
    LastName: string;
    Email: string;
    IsConsultant: boolean;
    Phone: string;
    PostalCode: string;
    City: string;
    Sourcer: boolean;
    InternalRoles: string[];
    EngagementManagerHierarchyLayer: number;
    EngagementManagerId: string;
    LTCoachId: string;
    FirestaerterId: string;
    EmployerId: string;
    Longitude: number;
    Latitude: number;
    FunctionLevel: string;
    FunctionDescription: string;
    Profile: string;
    StartDate: Date;
    TechNonTech: string;
    CurrentAvailability: number;
    TribeId: string;
    TribeName: string;
    HiveId: string;
    HiveName: string;
    CoachRoles: CoachRole[];
    _links: {
        Avatar: Link;
        SkilldLink: string;
        CapacityPlanLink: string;
    };
}

export interface IEmployeeSkill {
    SkillId: string;
    EmployeeId: string;
}

export interface IEmployeeGeoLookUpAERepresentation {
    address: string;
    latitude: string;
    longitude: string;
    isFound: boolean;
    cachedResult: boolean;
}

export interface IEmployeeAERepresentation {
    addressCountry: string;
    addressPlace: string;
    addressPostalCode: string;
    addressStreet: string;
    addressHouseNumber: string;
    contractType: string;
    emailAddress: string;
    employeeId: string;
    employeeType: string;
    employerId: string;
    endDate: string;
    engagementManagerEmployeeId: string;
    firstName: string;
    functionProfileId: string;
    lastName: string;
    latitude: string;
    longitude: string;
    ltCoachEmployeeId: string;
    firestaerterEmployeeId: string;
    mobileWork: string;
    startDate: string;

    weeklyAvailabilities: IEmployeeWeeklyAvailabilitiesAeRepresentation[];
    allocations: IAllocationAERepresentation[];
    skills: string[] | IEmployeeSkillAERepresentation[];
    workschedules: IEmployeeWorkScheduleAERepresentation[];
    tribe: ITribeAERepresentation;
}

export interface IEmployeeWeeklyAvailabilitiesAeRepresentation {
    weeklyCapacity: number;
    wtartDate: string;
    employeeId: string;
}

export interface IEmployeeWorkScheduleAERepresentation {
    hoursPerWeek: string;
    startDate: string;
    endDate: string; // Potentially absent if workschedule has no specific end.
}

export interface IEmployeeSkillAERepresentation {
    skillId: string;
}

export interface ISeniority {
    Name: string;
    Code: string;
    Order: number;
}

export class ContractType {
    public static regular: string = 'Regular';
    public static sourcer: string = 'Sourcer';
}

export class EmployeeType {
    public static consultant: string = 'Consultant';
    public static internal: string = 'Internal';
}

export enum CoachRole {
    Firestaerter = 'Firestaerter',
    EngagementManager = 'EngagementManager',
    LTCoach = 'LTCoach'
}
